import React, { FC, useCallback } from 'react';

import { IButtonVerticalItem } from '../../../common/messageCreators';
import { ButtonLinkWrapper } from '../ButtonLinkWrapper/ButtonLinkWrapper';
import { ButtonContent } from './ButtonContent';

type ButtonsVerticalItemProps = {
  item: IButtonVerticalItem;
  position: number;
  onClick: (item, position) => void;
};

export const ButtonsVerticalItem: FC<ButtonsVerticalItemProps> = ({ item, position, onClick }) => {
  const clickHandler = useCallback(() => {
    onClick(item, position);
  }, [item, position, onClick]);

  return (
    <ButtonLinkWrapper
      link={item.link}
      onClick={clickHandler}
      data-hook="item"
      data-chatbot-btn-id={item._id}
    >
      <ButtonContent label={item.label} sublabel={item.sublabel} icon={item.icon} />
    </ButtonLinkWrapper>
  );
};
